import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { BehaviorSubject, map } from 'rxjs';
import { createHttpParams } from '~/infrastructure/http/params';
import { augmentPaging } from '~/infrastructure/paging';
import { SendReportEmailModel } from '~/models/modules/SendReportEmailModel';
import { ApiServiceBase, API_NAMES } from '~/services/api';
import { EnvironmentLoaderService } from '~/services/BackEndURL/environment-loader.service';

@Injectable({ providedIn: 'root' })
export class ReportsService extends ApiServiceBase {

  refreshPage: BehaviorSubject<string> = new BehaviorSubject<string>(null);

  constructor(injector: Injector, private http: HttpClient) {
    super(injector);
    this.setBase(API_NAMES.modules);
  }
  refreshReports(x: any, edit: boolean = false, deleteReport: boolean = false) {
    if (edit)
      this.refreshPage.next("edit," + (x as string));
    else if (deleteReport) {
      this.refreshPage.next("delete," + (x as string));
    }
    else {
      this.refreshPage.next((x as string));
    }
  }

  getFavoriteReportCountsByModuleAndIds(isAsset: boolean = false, isCatalog: boolean = false, isForecast: boolean = false, favoriteReportIds: any[], isEnterprise: boolean = false, siteId: number = null) {
    siteId = siteId ? siteId : 0;
    let param = { FavoriteReportIds: favoriteReportIds, IsAsset: isAsset, IsCatalog: isCatalog, IsForecast: isForecast, isEnterprise, SiteId: siteId };
    return this.http.post<any>(this._url(`/getFavoriteReportCountsByModuleAndIds`), param);
  }

  categories(system: boolean, isCatalog: boolean, isAsset: boolean = false, isEnterprise: boolean = false, siteId: number = null) {
    siteId = siteId ? siteId : 0;
    return this.http.get<any>(this._url(`/categories/${system}/${isCatalog}/${isAsset}/${isEnterprise}/${siteId}`));
  }

  AllCategories(isAsset: boolean = false) {
    return this.http.get<any>(this._url(`/all-categories/${isAsset}`));
  }
  ReportsByCategoryAllSitesOnly(name: string, isAsset: boolean = false) {
    let param = { CategoryName: name, isAsset: isAsset };
    return this.http.post<any>(this._url(`/ReportsByCategoryAllSitesOnly`), param);
  }

  ReportsByCategory(id: number, system: boolean, isCatalog: boolean, isAsset: boolean = false, isEnterprise: boolean = false, siteId: number = null) {
    siteId = siteId ? siteId : 0;
    let param = { CategoryId: id, SystemReport: system, IsCatalog: isCatalog, isAsset: isAsset, isEnterprise: isEnterprise, siteId: siteId };
    return this.http.post<any>(this._url(`/ReportsByCategory`), param);
  }


  ReportsByCategoryName(name: string, isAsset: boolean = false, siteId: number = null) {
    let param = { CategoryName: name, isAsset: isAsset, siteId: siteId };
    return this.http.post<any>(this._url(`/ReportsByCategory`), param);
  }

  ReportsByMultipleCategoryAllSitesOnly(categoryData: any[]) {
    return this.http.post<any>(this._url(`/ReportsByMultipleCategoryAllSitesOnly`), categoryData);
  }
  ReportsByMultipleCategory(categoryData: any[]) {
    return this.http.post<any>(this._url(`/ReportsByMultipleCategory`), categoryData);
  }

  GetReportbyDataSourceName(datasourcename: string) {
    return this.http.get<any>(this._url(`/${datasourcename}`));
  }

  GetReportData_GET(datasourcename: string) {
    return this.http.get<any>(datasourcename);
  }

  ProcessForecast(forecastConfig: any) {
    return this.http.post<any>(this._url(`/ProcessForecast`), forecastConfig);
  }

  ProcessStandardForecast(config: any) {
    return this.http.post<any>(this._url(`/ProcessStandardForecast`), config);
  }

  GetForecastMonthToMonth(config: any) {
    return this.http.post<any>(this._url(`/ForecastMonthToMonth`), config);
  }

  GetReportCounts(siteId: number = null) {
    siteId = siteId ? siteId : 0;
    return this.http.get<any>(this._url(`/GetReportCounts/${siteId}`));
  }

  ReportById(reportid: number) {
    return this.http.get<any>(this._url(`/${reportid}`));
  }

  BarcodeLabelById(reportid: string) {
    return this.http.get<any>(this._url(`/barcodelabelbyid/${reportid}`));
  }
  ReportIdByName(reportname: string) {
    return this.http.get<any>(this._url(`/reportidbyname/${reportname}`));
  }

  getForecasts(system: boolean) {
    return this.http.get<any>(this._url(`/Forecasts/${system}`));
  }

  saveReport(model: any) {
    return this.client.put<string>(this._url(`/${model.id}`), model);
  }
  saveReportForBarcodeLabel(model: any) {
    return this.client.put<string>(this._BarcodeLabelUrl(`/${model.id}`), model);
  }

  saveNewReport(model: any) {
    return this.client.post<string>(this._url(), model);
  }

  createScheduleReport(model: any) {
    return this.client.post<string>(this._url(`/schedulereport`), model);
  }

  updateScheduleReport(id: number, model: any) {
    return this.client.put(this._url(`/schedulereport/${id}`), model);
  }

  Copy(id: number, newName: string, isCatalog: boolean = false, isAsset: boolean = false, isEnterprise: boolean = false) {
    return this.client.get<any>(this._url(`/Copy/${id}/${newName}/${isCatalog}/${isAsset}/${isEnterprise}`));
  }

  saveForecast(reportId: number, reportObject: any) {
    if (reportId) {
      return this.client.put<any>(this._url(`/${reportId}`), reportObject);
    }
    else {
      return this.client.post<any>(this._url(), reportObject);
    }
  }

  PreviewReportData(reportObject: any) {
    var apiUrl = EnvironmentLoaderService.envConfig.enterpriseApiLocal + '/';
    reportObject.apiUrl = apiUrl;
    if (reportObject) {
      if (typeof reportObject.addLogo === 'string') {
        reportObject.addLogo = reportObject.addLogo.toLowerCase() === 'yes';
      }
      if (typeof reportObject.addAddress === 'string') {
        reportObject.addAddress = reportObject.addAddress.toLowerCase() === 'yes';
      }
    }
    return this.client.post<any>(this._url('/preview-report-data'), reportObject);
  }

  GetReportData(reportId: number, filterObject: any, siteId: number) {
    let filter = {
      transactionId: filterObject == null ? -1 : filterObject,
      selectedFields: 0,
      selectByField: 0,
      siteId: siteId,
      apiUrl: EnvironmentLoaderService.envConfig.enterpriseApiLocal + '/'
    };

    //reportObject.apiUrl = apiUrl;
    return this.client.post<any>(this._url(`/get-report-data/${reportId}`), filter);
  }

  GetReportDataForBarcodeLabel(reportName: string, filterObject: any, paramsObj?: any, model?: any) {
    let filter;
    if (filterObject == null) {
      filterObject = { transactionId: -1 };
    }
    else {
      filter = filterObject;
    }

    var apiUrl = EnvironmentLoaderService.envConfig.enterpriseApiLocal + '/';
    filter.apiUrl = apiUrl;
    paramsObj = paramsObj || {};
    paramsObj.view = 'summary';
    let params = createHttpParams(paramsObj);

    return this.client.post<any>(this._url(`/get-report-data-barcode-label?reportName=${reportName}`), filter, {
      params,
      observe: 'response',
    }).pipe(map(augmentPaging));
  }

  GetReportDataForBarcodeLabelDesigner(reportId: number, filterObject: any, tableName?: string, returnQuantity?: boolean, selectedFields?: string) {
    // let filter;
    // if (filterObject == null) {
    //   filter = { transactionId: -1 };
    // }
    // else {
    //   filter = filterObject;
    // }
    let filter = {
      transactionId: filterObject == null ? -1 : filterObject,
      apiUrl: EnvironmentLoaderService.envConfig.enterpriseApiLocal + '/',
      tableName: tableName,
      returnQuantity: returnQuantity,
      selectedFields: selectedFields
    };

    return this.client.put<any>(this._url(`/get-report-data-for-barcode-label-designer/${reportId}`), filter).pipe(
      map(response => response?.data ?? response?.Data ?? response)
    );
  }

  GetSelectByPrimaryValuesData(filterObject: any) {

    return this.client.post<any>(this._url(`/get-select-by-primary-values`), filterObject);
  }

  deactivateReport(obj: any) {
    return this.client.put(this._url(`/deactivate`), obj);
  }

  sendEmail(EmailReportModel: SendReportEmailModel) {

    return this.client.post<any>(this._url(`/sendReportEmail`), EmailReportModel);
  }

  private _url(v?: string | undefined) {
    v = v || '';
    return this.url(`/reports${v}`);
  }
  private _BarcodeLabelUrl(v?: string | undefined) {
    v = v || '';
    return this.url(`/Labels${v}`);
  }
}
